import * as React from 'react';
import System from 'src/helper/system';

const ContactUsPopup = (props) => {
    const { SetStatus, data } = props;
    const { translation:t } = System;

    const validateRestrictOrderBlock = () => {
        return !!(data.restrict || data.order_block);
    }
    const isValid = validateRestrictOrderBlock();
    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{isValid ?  t('contactUs') :  t('generalSupport')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            {isValid ?
                                (data.order_block ?
                                    <>
                                        <p className='mb-0 mt-3 text-center'>{t('troubleProcessingRequest')} <br /> {t('reachOutLocalSales')} <br /> {t('indicatedUnderMyContacts')}.</p>
                                    </> :
                                    <>
                                        <p className='mb-0 mt-3 text-center'>{t('dontHavePermissionsForThisAction')}. <br /> {t('contactYourSupportTeam')}.</p>
                                    </>
                                ):
                                <>
                                    <p className='mb-0 text-center'>
                                        {t('contactLocalSales')}<br />{t('youCanFindInMyContacts')}
                                    </p>
                                </>
                            }
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className={isValid ? "bs5 btn btn-sm btn-primary" : "bs5 btn btn-secondary btn-sm"} data-dismiss="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                {t('close')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactUsPopup;